<script setup>
import {ref, onMounted, computed, reactive} from 'vue'
import {getUser, updateUser} from '@/services/api/auth.js'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleError} from "@/utils/errors.js";
import messageService from '@/services/messages.js'
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import {useRoute} from "vue-router";
import {
    getServiceTypesById,
    saveServiceTypes,
} from "@/services/api/serviceTypes.js";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {ServiceTypesEntity} from "@/entities/ServiceTypesEntity.js";
import {buildPayloadFromEntity} from "@/utils/index.js";

const { t } = useI18n();
const route = useRoute();
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const form = ref(null);
const serviceTypesEntity = new ServiceTypesEntity();
const entity = ref(serviceTypesEntity);
const isFetching = ref(false);
const formData = ref(entity.value.getDefaultValues());
const fieldsDisabled = ref(false);

async function onSave() {
    try {
        const { valid } = await form.value.validate();
        if (!valid) return;

        loading.value = true;

        formData.value.id = id ?? null;
        const payload = buildPayloadFromEntity({entity: entity.value, data: formData.value});
        payload.id = formData.value.id ?? null;
        await saveServiceTypes(payload);
        await router.push(entity.value.pages.list.route?.at(-1));
        message.success(t("common.messages.success.save"));

    } catch (error) {
        console.error(error);
        message.error(await handleError(error, t, formData?.value?.name));
    } finally {
        loading.value = false;
    }
}


onMounted(async () => {
    try {
        isMounted.value = false;

        if (id) {
            const response = await getServiceTypesById({ id });
            fieldsDisabled.value = response.data.read_only;
            formData.value = response.data;
        }

    } catch (error) {
        console.error("Erro ao montar o componente:", error);
    } finally {
        isMounted.value = true;
    }
});

</script>

<template >
    <BasePage :loading-mounted="isMounted" :entity="entity">
        <template #default>
            <EntityForm :entity="entity" v-model="formData" :disabled="fieldsDisabled" ref="form" />
            <ButtonSave :loading="loading"  @click="onSave" />
        </template>
    </BasePage>
</template>
